/// <amd-module name="Artifacts/Connect/redux/Reducers" />
import { ConnectToFeedActions, ConnectToFeedActionTypes } from "Artifacts/Connect/redux/Actions";
import { IConnectToFeedContainerState } from "Artifacts/Connect/redux/Contracts";
import produce from "immer";
import { Uri } from "VSS/Platform/Util/Url";

export const connectToFeedReducer = produce(
  (draft: IConnectToFeedContainerState, action: ConnectToFeedActions) => {
    switch (action.type) {
      // TODO: Add componentState to propery handle Loading and Error state
      case ConnectToFeedActionTypes.DismissFirstTimeMessage:
        draft.dismissedTools.push(action.payload);
        break;
      case ConnectToFeedActionTypes.InitializeConnectToFeedState:
        draft.dismissedTools = action.payload.dismissedTools;
        draft.packagingUrl = action.payload.packagingUrl;
        draft.sessionTokenUri = action.payload.sessionTokenUri;
    }
  },
  { dismissedTools: [], packagingUrl: "", sessionTokenUri: new Uri("") },
);
